import("./bootstrap.tsx");
